import './Modal.css';

const Modal = ({ message, onConfirm, onCancel }) => {
    return (
        <div className="modal-overlay">
            <div className="modal">
                <p>{message}</p>
                <div className="modal-buttons">
                    <button onClick={onConfirm} className="confirm-button hide">예</button>
                    <button onClick={onCancel} className="cancel-button hide">아니오</button>
                </div>
            </div>
        </div>
    );
};

export default Modal;
